import { render, staticRenderFns } from "./dangerousGoodsListOperatingInstruction.vue?vue&type=template&id=1db1febe"
import script from "./dangerousGoodsListOperatingInstruction.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListOperatingInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports